import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=1a23d358&scoped=true&"
import script from "./SideDrawer.vue?vue&type=script&lang=ts&"
export * from "./SideDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=1a23d358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23d358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
